import { Motion, Presence } from "@motionone/solid"
import { createEffect, createSignal, onCleanup } from "solid-js"
import { Dynamic, Show, Portal } from "solid-js/web"
import { useHeroForm } from "../contexts/HeroFormContext"
import { twMerge } from "tailwind-merge"


const SelectorArrow = () => (
  <svg width="17" height="10" viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.125 1.3125L8.5 8.6875L15.875 1.3125" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  </svg>

)

const StandardSizeThumbnail = (props) => {
  return (
    <Show
      fallback={<div class="mr-2 w-10 h-10"></div>}
      when={props.thumbnailSrc != undefined && props.thumbnailSrc.length > 0}>
      <div class="mr-2 w-10 h-10 border border-solid border-frame">
        <img src={props.thumbnailSrc} alt="" />
      </div>
    </Show>
  )
}

export const STANDARD_SIZE_DROPDOWNS = Object.freeze({
  V1: 1,
  V2: 2
})

const StandardSizeDropDownGrp = (props) => {
  const label = () => props.label;
  const valueOptions = () => props.valueOptions;
  const selectedOptionId = () => props.selectedOptionId;
  const initialDisabledOption = () => props.initialDisabledOption;

  const handleSelection = ({ target }) => {
    const selectedValue = target.value;
    props.handleSelection(props.id, handleize(selectedValue));
  }


  return (
    <div class="flex flex-col justify-between py-2 w-full items-start px-2 sm:px-6">
      <div>{label()}</div>
      <select
        class={twMerge(
          "py-2 pl-2 pr-2 min-w-25 sm:min-w-30 w-full appearance-none cursor-pointer border-outer border-solid border-frame bg-transparent bg-no-repeat custom-select",
          props.dropdownClass ?? ""
        )}
        style={{
          "background-image": `url(${selectorDownArrowDark})`,
          "background-size": "12px"
        }}
        name={label()}
        id={`standard-size-${props.id}`}
        onChange={handleSelection}
      >
        <Show
          when={initialDisabledOption()}
        >
          <option selected={selectedOptionId().trim().length === 0 ? "true" : ''} disabled="true">Choose {label()}</option>
        </Show>
        <For each={valueOptions()}>{(option, index) => {
          return (
            <option
              value={option['value']}
              {...(option['id'] === selectedOptionId() ? { selected: 'true' } : {})}
            >
              {option['displayName']}
            </option>
          )
        }}</For>
      </select>

    </div>
  )
}

const StandardSizeDropDownGrpV2 = (props) => {
  const label = () => props.label;
  const valueOptions = () => props.valueOptions;
  const selectedOptionId = () => props.selectedOptionId;
  const initialDisabledOption = () => props.initialDisabledOption;

  const selectedValueDisplayName = () => {
    const displayName = valueOptions().filter(option => option.id == selectedOptionId())[0]?.displayName;
    if (displayName) {
      const displayNameArr = displayName.split(' ');
      return `<strong class="font-bold">${displayNameArr[0]}</strong> ${displayNameArr.slice(1,displayNameArr.length).join(' ')}`
    } else {
      return ''
    } 
  }

  const [openOptions, setOpenOptions] = createSignal(false);

  const handleOptionOpen = (state = undefined) => {
    setOpenOptions(prevState => state != undefined ? state : !prevState);

    if (openOptions() == true) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  }

  const handleModalParentClick = ({ target }) => {
    const labelHandleized = handleize(label());
    const closableParents = [`${labelHandleized}-outer-parent`, `${labelHandleized}-inner-parent`]
    const id = target.id;

    if(closableParents.includes(id)) {
      handleOptionOpen(false);
    }
  }

  onCleanup(() => {
    document.body.style.overflow = "";
  })

  createEffect(() => {
    const close = (e, currentState) => {
      if (e.key === "Escape" && currentState === true) {
        handleOptionOpen(false)
      }
    }

    document.addEventListener('keydown', (e) => close(e, openOptions()));

    onCleanup(() => document.removeEventListener('keydown', close));
  })
  
  const handleSelection = (selectedValue) => {
    props.handleSelection(props.id, handleize(`${selectedValue}`));
  }

  return (
    <div class="w-full bg-canvas">
      <div
        class={twMerge(
          "flex flex-col justify-between p-1 items-start   custom-select select-wrap relative bg-canvas  bg-no-repeat cursor-pointer min-w-25 sm:min-w-30 border-outer border-solid custom-select",
          props.dropdownClass ?? ""
        )}
        classList={{
          "border-[#FF0000]": selectedValueDisplayName() == undefined,
          "border-frame": selectedValueDisplayName() != undefined
        }}
        style={{
          "background-image": `url(${selectorDownArrowDark})`,
          "background-size": "12px"
        }}
        onClick={() => { handleOptionOpen(); }}
      >
        <label
          onclick
          for={`standard-size-${props.id}`}
          class="font-bold text-sm"
        >{label()}</label>
        <div>
          <span class="text-xs sm:text-sm md:text-base" innerHTML={selectedValueDisplayName() == undefined ? `Choose ${label()}` : selectedValueDisplayName()}></span>
        </div>       
      </div>
      <Portal>
        <Presence>
          <Show when={openOptions()}>
            <Motion.div
              initial={{ opacity: 0, scale: 1, z:9999 }}
              animate={{ opacity: 1, scale: 1, z:9999 }}
              exit={{ opacity: 0, scale: 1, z:9999 }}
              transition={{ duration: 0.3 }}
              class="fixed z-[999999] right-0 w-full h-full border-b-0 top-0"
            >
              <div class="w-full h-full absolute top-0 left-0 backdrop-mk"
                onClick={() => { handleOptionOpen(false) }}
              ></div>
              <div id={`${handleize(label())}-outer-parent`} class="p-2 w-full sm:landscape:w-1/2 absolute right-0 top-1/2 -translate-y-1/2 boxy-shadow h-full flex justify-center" onClick={handleModalParentClick}>
                <div id={`${handleize(label())}-inner-parent`} class="flex flex-col justify-center h-full max-w-prose w-full" onClick={handleModalParentClick}>
                  <div class="flex items-center justify-between -mb-[1px] cursor-pointer  group bg-primary-900 border-frame border-t border-x"
                  >
                    <span class="p-1 font-bold uppercase group-hover:text-secondary-50 text-secondary-100  ">{label() != undefined && label() != null && label()?.trim()?.length > 0 ? `Choose ${label()}` : ''}</span>
                    <div class="border-b border-l border-l-secondary-100 block border-frame p-1 z-20  group-hover:text-secondary-50 text-secondary-100 font-bold uppercase"
                      onClick={() => { handleOptionOpen(false) }}
                    ><svg aria-label="Close Icon" xmlns="http://www.w3.org/2000/svg" class="inline-block" height="32" viewBox="0 -960 960 960" width="32"><path fill="currentColor" d="m248.667-188.667-58.667-60L421-480 190-712.667l58.667-59.999L481-540l230.333-232.666L770-712.667 539.666-480 770-248.667l-58.667 60L481-421.334 248.667-188.667Z"/></svg></div></div>
                  <div class="border border-solid border-frame  overflow-y-scroll overflow-x-hidden themed-scrollbar max-h-[calc(var(--vh,1vh)*100-6rem)] bg-canvas "
                  >
                    <For each={valueOptions()}>{(option, index) => {
                      return (
                        <span
                          class="flex gap-1 p-2 items-center border-frame hover:bg-canvas-lightborder-frame border-b-outer hover:bg-canvas-light last:border-b-outer cursor-pointer"
                          onClick={() => handleSelection(option['value'])}
                        >
                          {option['displayName']}
                        </span>
                      )
                    }}</For>
                  </div>
                </div>
              </div>
            </Motion.div>
          </Show>
        </Presence>
      </Portal>
    </div>
  )
}

const standardSizeDropDowns = {
  [STANDARD_SIZE_DROPDOWNS.V1]: StandardSizeDropDownGrp,
  [STANDARD_SIZE_DROPDOWNS.V2]: StandardSizeDropDownGrpV2
}

const AnchorGradedMeasurement = (props) => {
  const label = () => props.measurement.label;
  const measureValues = () => Object.values(props.measurement.values)
  const selectedFitHandleized = () => handleize(props.selectedFit)
  const thumbnailSrc = () => props.measurement.thumbnailSrc;
  const selected = () => props.measurement.selected;

  const valueOptions = () => (
    measureValues().map(value => ({
      "id": handleize(value['baseSize']),
      "value": value['baseSize'],
      "displayName": value['displayName'][selectedFitHandleized()]
    }))
  )

  return (
    <div class="flex items-center w-full">
      <Show
        when={props.isThereAnyThumbnail}>
        <StandardSizeThumbnail
          thumbnailSrc={thumbnailSrc()}
        />
      </Show>
      <Show
        fallback={(
          <StandardSizeDropDownGrp
            label={label()}
            id={props.measurement.id}
            valueOptions={valueOptions()}
            selectedOptionId={selected()}
            initialDisabledOption={false}
            handleSelection={props.handleSelection}
          />
        )}
        when={props.version != undefined}
      >
        <Dynamic
          component={standardSizeDropDowns[props.version]}
          label={label()}
          id={props.measurement.id}
          valueOptions={valueOptions()}
          selectedOptionId={selected()}
          initialDisabledOption={false}
          handleSelection={props.handleSelection}
          dropdownClass={props.dropdownClass}
        />
      </Show>
    </div>
  )
}

const NonAnchorUngradedMeasurement = (props) => {
  const label = () => props.measurement.label;
  const values = () => {
    const min = props.measurement.values['min'];
    const max = props.measurement.values['max'];
    const step = props.measurement.values['step'];

    const result = [];

    for (let i = min; i <= max; i += step) {
      result.push(i);
    }

    return result;
  };
  const selected = () => props.measurement.selected;

  const valueOptions = () => (
    values().map(value => {
      const fixedValue = parseFloat(parseFloat(`${value}`).toFixed(2));

      return {
        "id": handleize(`${fixedValue}`),
        "value": fixedValue,
        "displayName": displayNameTemplate().replace("{{1}}", fixedValue)
      }
    })
  )

  const displayNameTemplate = () => props.measurement.displayNameTemplate;
  const thumbnailSrc = () => props.measurement.thumbnailSrc;

  return (
    <div class="flex items-center w-full">
      <Show
        when={props.isThereAnyThumbnail}>
        <StandardSizeThumbnail
          thumbnailSrc={thumbnailSrc()}
        />
      </Show>
      <Show
        fallback={(
          <StandardSizeDropDownGrp
            label={label()}
            id={props.measurement.id}
            valueOptions={valueOptions()}
            selectedOptionId={selected()}
            initialDisabledOption={true}
            handleSelection={props.handleSelection}
          />
        )}
        when={props.version != undefined}
      >
        <Dynamic
          component={standardSizeDropDowns[props.version]}
          label={label()}
          id={props.measurement.id}
          valueOptions={valueOptions()}
          selectedOptionId={selected()}
          initialDisabledOption={true}
          handleSelection={props.handleSelection}
          dropdownClass={props.dropdownClass}
        />
      </Show>

    </div>
  )
}

export const StandardMeasurementDiv = (props) => {

  const standardMeasurementElems = {
    "anchorGraded": AnchorGradedMeasurement,
    "nonAnchorUngraded": NonAnchorUngradedMeasurement,
    "nonAnchorGraded": null
  }

  return <Dynamic component={standardMeasurementElems[props.type]} {...props} />
}